export const baseUrl = "https://api.owave.co/api"; 